export default{
  getSearchCoursesStatus: (state) => state.searchCoursesStatus,
  getSearchCoursesType: (state) => state.searchCoursesType,
  getSearchCoursesCategory: (state) => state.searchCoursesCategory,
  getSearchCoursesTeacher: (state) => state.searchCoursesTeacher,
  getSearchCoursesHot: (state) => state.searchCoursesHot,
  getSearchCoursesLevel: (state) => state.searchCoursesLevel,
  getSearchCoursesFacult: (state) => state.searchCoursesFacult,
}



// WEBPACK FOOTER //
// ./src/components/courses/store/getters.js